import { get } from 'lodash';
import { func, object, string } from 'prop-types';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import {
  getReactSelectValue,
  ReactSelectInput,
} from '@hivebrite/design-system/Inputs';

import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import { useBuilderConfigContext } from 'hb-builder/hooks';
import { INITIAL_FONTS, loadFont, mapFonts } from 'hb-builder/utils/fonts';
import { getCustomFontName } from 'hb-react/backoffice/components/PageBuilder/utils/getCustomFontName';

const FontFamily = ({
  defaultAttributes,
  item,
  onChange,
  settingKey,
  title,
}) => {
  const {
    features: {
      text: { fonts },
    },
    hivebrite: { networkFont, networkTheming },
  } = useBuilderConfigContext();

  const [value, setValue] = useState(
    get(item.attributes, settingKey) ||
      get(defaultAttributes, settingKey) ||
      networkFont ||
      INITIAL_FONTS[0],
  );

  const options = fonts || mapFonts(INITIAL_FONTS);

  useEffect(() => {
    setValue(get(item.attributes, settingKey));
  }, [get(item.attributes, settingKey)]);

  const handleChange = (e) => {
    const customFontName = getCustomFontName(networkTheming);

    if (customFontName !== e.value) {
      loadFont(e.value);
    }
    setValue(e.value);

    onChange({
      id: item.id,
      settingKey: `attributes.${settingKey}`,
      value: e.value,
    });
  };

  const formattedValue = getReactSelectValue(options, value);

  return (
    <Wrapper>
      <InputTitle id="settingsFontFamily-input" label={title} position="left" />
      <ReactSelectInput
        data-testid="settingsFontSize"
        id="settingsFontFamily"
        name="settingsFontFamily"
        onChange={handleChange}
        options={options}
        placeholder={value}
        value={formattedValue}
        variant="small"
        width={155}
      />
    </Wrapper>
  );
};

export default FontFamily;

const Wrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  mb: 4,
}))``;

FontFamily.defaultProps = {
  title: __('Font family'),
};

FontFamily.propTypes = {
  defaultAttributes: object,
  item: object.isRequired,
  onChange: func.isRequired,
  settingKey: string.isRequired,
  title: string.isRequired,
};
